module.exports = __webpack_public_path__ + "static/media/real-estate@2x.405e1ae8.png";